/**
 * Timekeeper rotation: one timekeeper takes all six robots of a match before moving on.
 *
 * Each Timekeeper submit moves to the next robot - position 1 → 2 → 3, then the other
 * alliance's 1 - and only after all six does the match number go up. Six steps bring the
 * scout back to the spot they started on. A normal (Count Mode) submit ends the rotation:
 * the counter goes and the match number goes up by one as usual.
 *
 * Kept in localStorage per event and match type, so a reload mid-match keeps the count.
 */

export const ROBOTS_PER_MATCH = 6;

const KEY = 'timekeep_rotation';

/** The robot after this one: next position, or the other alliance's position 1 after 3. */
export function nextSpot(color, position) {
    const pos = parseInt(position);
    if (pos >= 1 && pos < 3) return { color, position: pos + 1 };
    return { color: color === 'r' ? 'b' : 'r', position: 1 };
}

/**
 * After a Timekeeper submit at (color, position) in this match.
 * @returns {{ rotation: object|null, spot: {color, position}, nextMatch: boolean }}
 *   rotation - the saved state (null once all six are done), spot - where to go next,
 *   nextMatch - true when the match number should go up
 */
export function advanceRotation(rotation, { eventPath, gamemode, match, color, position }) {
    const same = rotation && rotation.eventPath === eventPath && rotation.gamemode === gamemode
        && String(rotation.match) === String(match);
    const count = (same ? rotation.count : 0) + 1;
    const spot = nextSpot(color, position);
    if (count >= ROBOTS_PER_MATCH) return { rotation: null, spot, nextMatch: true };
    return { rotation: { eventPath, gamemode, match: String(match), count }, spot, nextMatch: false };
}

/** The rotation in progress for this event / match type, or null. */
export function loadRotation(eventPath, gamemode) {
    try {
        const r = JSON.parse(localStorage.getItem(KEY) || 'null');
        return r && r.eventPath === eventPath && r.gamemode === gamemode ? r : null;
    } catch {
        return null;
    }
}

export function saveRotation(rotation) {
    try {
        if (rotation) localStorage.setItem(KEY, JSON.stringify(rotation));
        else localStorage.removeItem(KEY);
    } catch { /* storage full or blocked: the counter just isn't kept */ }
}
